const fakeData = [
    { 
        place: "COX'S BAZAR",
        placeImage: 'https://i.ibb.co/9sYsXN6/Rectangle-1.png',
        stays: 252,
        date: 'Apr 13-17', 
        shortDescription: "Cox's Bazar is a city, fishing port, tourism centre and district headquarters in southeastern Bangladesh. It is famous mostly for its long natural sandy beach, and it ...",
        longDescription: "Cox’s Bazar is a town on the southeast coast of Bangladesh. It’s known for its very long, sandy beachfront, stretching from Sea Beach in the north to Kolatoli Beach in the south. Aggameda Khyang monastery is home to bronze statues and centuries-old Buddhist manuscripts.",
        hotel: [
            {
                imageUrl: 'https://i.ibb.co/QvySjL1/Rectangle-26.png',
                name: 'Light bright airy stylish apt & safe peaceful stay',
                guest: 4,
                bed: 2,
                bedroom: 2,
                bath: 2,
                kitchen: 'Wif Air conditioning Kitchen',
                cancellationFlexibility: true,
                rating: 4.9,
                review: 20,
                costPerNight: 34,
                total: 167,
            },
            {
                imageUrl: 'https://i.ibb.co/kGsnTD1/Rectangle-27.png',
                name: 'Apartment in Lost Panorama',
                guest: 2,
                bed: 1,
                bedroom: 1,
                bath: 1,
                kitchen: 'Well ventilated Kitchen',
                cancellationFlexibility: false,
                rating: 4.8,
                review: 10,
                costPerNight: 52,
                total: 219,
            },
            {
                imageUrl: 'https://i.ibb.co/fxcQv07/Rectangle-28.png',
                name: 'AR Lounge & Pool (r&r + b&b)',
                guest: 5,
                bed: 3,
                bedroom: 2,
                bath: 3,
                kitchen: 'Well Decorated Kitchen',
                cancellationFlexibility: true,
                rating: 4.9,
                review: 25,
                costPerNight: 45,
                total: 189,
            },
            
        ]
    },
    { 
        place: "SREEMANGAL",
        placeImage: 'https://i.ibb.co/vYD93NV/Sreemangal-2.jpg',
        stays: 150,
        date: 'Feb 08-27', 
        shortDescription: "It is said the name Sreemangal (or Srimangal) is named after Sri Das and Mangal Das; two brothers who settled on the banks of the Hail Haor. A copper plate ...",
        longDescription: "It is said the name Sreemangal (or Srimangal) is named after Sri Das and Mangal Das; two brothers who settled on the banks of the Hail Haor. A copper plate of Raja Marundanath from the 11th century was found in Kalapur. During an excavation at Lamua, an ancient statue of Ananta Narayan was dug out.",
        hotel: [
            {
                imageUrl: 'https://i.ibb.co/2k2dFMx/3d-rendering-interior-and-exterior-design.jpg',
                name: 'Hotel Paharika',
                guest: 3,
                bed: 2,
                bedroom: 1,
                bath: 2,
                kitchen: 'Furnished Kitchen',
                cancellationFlexibility: false,
                rating: 4.7,
                review: 10,
                costPerNight: 20,
                total: 150,
            },
            {
                imageUrl: 'https://i.ibb.co/C25WQdp/hotel-room.jpg',
                name: 'Ganchil Resort',
                guest: 2,
                bed: 1,
                bedroom: 2,
                bath: 1,
                kitchen: 'Well Decorated Kitchen',
                cancellationFlexibility: true,
                rating: 4.5,
                review: 5,
                costPerNight: 10,
                total: 90,
            },
            {
                imageUrl: 'https://i.ibb.co/qDLDRBZ/hotel-room-design-trends-italianbark-interior-design-blog.jpg',
                name: 'Hotel SkyLand',
                guest: 6,
                bed: 3,
                bedroom: 3,
                bath: 3,
                kitchen: 'Well Organized Kitchen',
                cancellationFlexibility: false,
                rating: 4.9,
                review: 45,
                costPerNight: 78,
                total: 350,
            },
            
        ]
    },
    { 
        place: "SUNDARBAN",
        placeImage: 'https://i.ibb.co/Qk82xzn/copy-of-1-sundarbans-syed-zakir-hossain-whatsapp-image-2020-05-20-at-7-59-51-pm-1589988023439.jpg',
        stays: 90,
        date: 'Oct 15-31', 
        shortDescription: "The Sundarbans is a mangrove area in the delta formed by the confluence of the Ganges, Brahmaputra and Meghna Rivers in the Bay of Bengal ...",
        longDescription: "The Sundarbans is a mangrove area in the delta formed by the confluence of the Ganges, Brahmaputra and Meghna Rivers in the Bay of Bengal. It spans from the Hooghly River in India's state of West Bengal to the Baleswar River in Bangladesh.",
        hotel: [
            {
                imageUrl: 'https://i.ibb.co/8g13TPk/3d-rendering-interior-and-exterior-design.jpg',
                name: 'Tirandaz-2',
                guest: 20,
                bed: 8,
                bedroom: 4,
                bath: 3,
                kitchen: 'Wif Air conditioning Kitchen',
                cancellationFlexibility: true,
                rating: 4.7,
                review: 30,
                costPerNight: 16,
                total: 120,
            },
            {
                imageUrl: 'https://i.ibb.co/sCmk3bv/900-modern-hotel-room.jpg',
                name: 'Badhshah-1',
                guest: 40,
                bed: 12,
                bedroom: 10,
                bath: 4,
                kitchen: 'Decorative Kitchen',
                cancellationFlexibility: false,
                rating: 4.8,
                review: 12,
                costPerNight: 21,
                total: 179,
            },
            {
                imageUrl: 'https://i.ibb.co/yhhtPJK/photo-1568495248636-6432b97bd949.jpg',
                name: 'Khulsi-3',
                guest: 20,
                bed: 15,
                bedroom: 9,
                bath: 3,
                kitchen: 'Well Decorated Kitchen',
                cancellationFlexibility: false,
                rating: 4.9,
                review: 100,
                costPerNight: 69,
                total: 159,
            },
            
        ]
    },
]

export default fakeData;